import { render } from "./Fungsional.vue?vue&type=template&id=7d90b272"
import script from "./Fungsional.vue?vue&type=script&lang=js"
export * from "./Fungsional.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__